// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__YFtg-","empty":"Cards_empty__Vjl1k"};